const MILLISECONDS_IN_AN_HOUR = 1000 * 60 * 60;

export const getHoursSinceImport = (lastImportAt: string | null) => (lastImportAt ? (Date.now() - new Date(lastImportAt).getTime()) / MILLISECONDS_IN_AN_HOUR : 0);
